import { render, staticRenderFns } from "./GrupoForm.vue?vue&type=template&id=6bc78ea0&"
import script from "./GrupoForm.vue?vue&type=script&lang=js&"
export * from "./GrupoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports